import React from 'react';
import { StatsCardStoryblok } from '../../../../types/storyblok';
import { Box } from '../../../../base/Box/Box';
import { Type } from '../../../../base/Type/Type';

const StatsCard = ({ heading, description }: StatsCardStoryblok) => (
  <Box as="article" overlayOverBkg>
    <Box as="div">
      <Type as="h3" className="font-helvetica text-h1">
        {heading}
      </Type>
      <Type as="p" className="mt-2 font-helvetica text-h2">
        {description}
      </Type>
    </Box>
  </Box>
);
export default StatsCard;
